export const calendarEventFieldLimits = {
  title: 300,
  description: 4_000,
  link: 2_048,
  previewDescription: 240,
} as const;

export const calendarEventDefaultTimes = {
  start: "09:00",
  end: "10:00",
} as const;

/** Weekday names are abbreviated to three letters ("Fri") wherever a recurrence is summarized. */
export const calendarWeekdayAbbreviationLength = 3;
